import { render, staticRenderFns } from "./GlobusConvocacaoPrincipal.vue?vue&type=template&id=0fdc28fa&"
import script from "./GlobusConvocacaoPrincipal.vue?vue&type=script&lang=js&"
export * from "./GlobusConvocacaoPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports